<div class="row">
  <div class="col-lg-6 col-12" *ngFor="let notice of notices">
    <app-notices-item [notice]="notice"></app-notices-item>
  </div>
</div>
